// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Menu_V2_Types_CrossSelling from "../Restaumatic.Menu.V2.Types.CrossSelling/index.js";
import * as Restaumatic_Menu_V2_Types_Ids_EntityId from "../Restaumatic.Menu.V2.Types.Ids.EntityId/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var Menu = function (x) {
    return x;
};
var newtypeMenu_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldMenu = function (dictHasField) {
    return dictHasField;
};
var eqMenu = {
    eq: function (x) {
        return function (y) {
            return Data_Eq.eq(Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_CrossSelling.eqCalculatedCrossSellingL))(x.calculatedCrossSellingList)(y.calculatedCrossSellingList) && x.name === y.name && x.onlineOrdering === y.onlineOrdering && Data_Eq.eq(Data_Eq.eqArray(Restaumatic_Menu_V2_Types_Ids_EntityId.eqEntityId))(x.sections)(y.sections);
        };
    }
};
var genericMenu = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showMenu = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericMenu)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "calculatedCrossSellingList";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "onlineOrdering";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "sections";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Menu_V2_Types_Ids_EntityId.showEntityId)))(Data_Show.showBoolean))(Data_Show.showString))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_CrossSelling.showCalculatedCrossSellingList)))))({
        reflectSymbol: function () {
            return "Menu";
        }
    }))
};
var unscrambleDecodeMenu = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericMenu)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "calculatedCrossSellingList";
        }
    })(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_CrossSelling.unscrambleDecodeCalculatedCrossSellingList))(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "name";
        }
    })(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "onlineOrdering";
        }
    })(Unscramble.decodeBoolean1)(/* #__PURE__ */ Unscramble.decodeRecordCons({
        reflectSymbol: function () {
            return "sections";
        }
    })(/* #__PURE__ */ Unscramble.decodeArray1(Restaumatic_Menu_V2_Types_Ids_EntityId.udecodeEntityId))(Unscramble.decodeRecordNil))))))))(Unscramble_Generic.defaultOptions)
};
var encodeMenu = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericMenu)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor({
        reflectSymbol: function () {
            return "Menu";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons()(Foreign_Generic_Class.encodeRecordNil)({
        reflectSymbol: function () {
            return "sections";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayEncode(Restaumatic_Menu_V2_Types_Ids_EntityId.encodeEntityId))))({
        reflectSymbol: function () {
            return "onlineOrdering";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.booleanEncode)))({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode)))({
        reflectSymbol: function () {
            return "calculatedCrossSellingList";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_CrossSelling.encodeCalculatedCrossSellingList)))))))
};
var decodeMenu = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericMenu)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor({
        reflectSymbol: function () {
            return "Menu";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(/* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons()(Foreign_Generic_Class.decodeRecordNil)({
        reflectSymbol: function () {
            return "sections";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.arrayDecode(Restaumatic_Menu_V2_Types_Ids_EntityId.decodeEntityId)))())({
        reflectSymbol: function () {
            return "onlineOrdering";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.booleanDecode))())({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())({
        reflectSymbol: function () {
            return "calculatedCrossSellingList";
        }
    })(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_CrossSelling.decodeCalculatedCrossSellingList)))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
export {
    Menu,
    genericMenu,
    eqMenu,
    showMenu,
    encodeMenu,
    decodeMenu,
    unscrambleDecodeMenu,
    hasFieldMenu,
    newtypeMenu_
};
//# sourceMappingURL=index.js.map
